import { AppConfig } from './AppConfig';

const baseUrl = 'https://www.pharmagarde.be';
const basePlannerUrl = 'http://ec2-63-32-71-102.eu-west-1.compute.amazonaws.com:8080';

const config: AppConfig = {
  configName: 'Uphoc-PROD',
  applicationTitle: 'WebGardes',
  hubUrl: `${baseUrl}/pharmagardeHub`,
  apiUrl: `${baseUrl}/api/`,
  plannerApiUrl: `${basePlannerUrl}/planner/`,
  googleMapApiKey: 'AIzaSyAHKfZ1yH7pudlmQ4441Plv9Aiic1tunQc',
  dateFormat: 'DD/MM/YYYY',
  dateFormatWithDay: 'ddd DD/MM/YYYY',
  dateTimeFormat: 'DD/MM/YYYY HH:mm',
};

export default config;
